import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__RadioButton_Radio_variants_js_e568ffcd__ from "../RadioButton/Radio.variants.js";
import * as __WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__ from "../../CdnIcon/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Label_index_js_02860227__ from "../../Label/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__ from "../../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Image_index_js_a1fee993__ from "../../Image/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__RadioButton_RadioButton_js_9c45a09b__ from "../RadioButton/RadioButton.js";
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
function RadioWithLabel(props) {
    const { labelClassName, labelProps = {}, labelNode, disabled, emphasis, size = '20', value, name, iconLeft, textStyle = 'body2', helperText = '', textRight = '', imageSrc = '', maxWidth = 24, height = 6 } = props;
    const { labelSlot, iconSlot, helperSlot, imageSlot, containerSlot, textRightSlot } = (0, __WEBPACK_EXTERNAL_MODULE__RadioButton_Radio_variants_js_e568ffcd__.radioButtonVariants)({
        emphasis,
        size,
        state: disabled ? 'disabled' : 'enabled'
    });
    const iconSlotClasses = iconSlot();
    const iconSize = textStyleIconSizes[textStyle] ?? '20';
    const labelClasses = (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__.cn)(labelSlot(), labelClassName);
    const textRightClasses = textRightSlot();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__Label_index_js_02860227__.Label, {
        className: labelClasses,
        ...labelProps,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__RadioButton_RadioButton_js_9c45a09b__.RadioButton, {
                disabled: disabled,
                emphasis: emphasis,
                size: size,
                value: value,
                name: name
            }),
            iconLeft && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__CdnIcon_index_js_4f7458e7__.CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: containerSlot(),
                children: [
                    labelNode,
                    helperText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: helperSlot(),
                        children: helperText
                    })
                ]
            }),
            imageSrc && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: imageSlot(),
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Image_index_js_a1fee993__.Image, {
                    src: imageSrc,
                    alt: "image",
                    maxWidth: maxWidth,
                    height: height,
                    objectFit: "contain",
                    objectPosition: "center"
                })
            }),
            textRight && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                className: textRightClasses,
                children: [
                    "(",
                    textRight,
                    ")"
                ]
            })
        ]
    });
}
export { RadioWithLabel };
